import { useCallback, useMemo } from 'react'
import { useField, useFormikContext } from 'formik'
import { SalesCenterWebhookModel } from '@user/store/scWebHooks'

type Props = {
  required: boolean
  name: string
}

export function useData(props: Props) {
  const { name, required } = props
  const { isSubmitting } = useFormikContext<SalesCenterWebhookModel>()

  const [{}, { error, touched }] = useField<string>({
    name,
    validate: (value) => {
      if (required && !value) {
        return 'Required'
      }
    },
  })

  const showError = Boolean(error && touched)

  const helperText = showError ? error : ''

  const options = useMemo(() => ['Status Change'], [])

  const getLabel = useCallback((option: string) => option, [])

  const getId = useCallback((option: string) => option, [])

  const initialOption = useMemo(() => {
    return 'Status Change'
  }, [])

  return {
    getLabel,
    getId,
    items: options,
    initialOption,
    isSubmitting,
    showError,
    helperText,
  }
}
